export default {
  tabbar1: "첫 페이지",
  tabbar2: "영화관",
  tabbar3: "선비",
  tabbar4: "투표",
  tabbar5: "개인",
  login: "로그인",
  userNamePlaceholder: "사용자 이름을 입력하십시오.",
  passwordPlaceholder: "암호를 입력하십시오.",
  forgotPassword: "비밀번호를 잊으셨습니까?",
  noAccount: "계좌번호 없어요?",
  registerNow: "지금 등록",
  register: "등록",
  inviteCodeePlaceholder: "초대 코드를 입력하십시오.",
  consentAgreement: "나는 이미 계좌 개설 협의의 각 조약을 알고 동의했다",
  highEndZone: "프리미엄 엔터프라이즈",
  EnjoyTheUltimateLuxuryExperience: "최고의 럭셔리 환경",
  airborne: "낙하",
  viewMoreData: "추가 데이터 보기",
  aboutCannonRecommend: "약포 추천",
  current: "현재",
  peopleNowMatch: "사람 온라인 일치",
  accountMembership: "약포 계정 입회 성공",
  highEnd: "하이엔드",
  authentication: "인증",
  videoAuthentication: "비디오 인증",
  tollRange: "요금 구간",
  personHeight: "키",
  bust: "가슴둘레",
  serviceCity: "서비스 도시",
  nationalAirborne: "전국 낙하산",
  askHerOut: "데이트 신청할게요",
  uptodate: "최신",
  play: "재생",
  reservation: "예약",
  beautifulGirl: "미소녀",
  people: "사람",
  requiredPromotion: "진급에 필요한",
  integral: "업 데이트",
  rechargePoints: "충전 포인트",
  redeemPoints: "환불을 신청하다",
  myActivityPoints: "총적분",
  currencySymbol: "포인트",
  basicInformation: "프로파일",
  personalReports: "개인 보고서",
  loginPassword: "로그인 암호",
  paymentPassword: "결제 비밀번호",
  taskLog: "작업 로그",
  noticeAnnouncement: "시스템 공지",
  onlineService: "온라인 고객 서비스",
  logOut: "로그인 종료",
  residence: "주소",
  reservationNow: "지금 예약",
  photo: "사진",
  video: "비디오",
  personalProfile: "프로필",
  popularRecommendations: "인기 추천",
  switchWindows: "창 전환",
  designatedTime: "기간",
  votingResults: "투표 결과",
  ISSUE: "기일",
  data: "데이터",
  big: "도쿄",
  small: "요코하마",
  one: "오사카",
  two: "나고야",
  currentSelectedNumber: "현재 선택 번호",
  pointsPerOrder: "포인트",
  inTotal: "합계",
  amountMoney: "금액",
  availablePoints: "사용 가능한 포인트",
  submitTo: "제출",
  artilleryEngagement: "약포 활동",
  recharge: "충전",
  payeeName: "수취인 이름",
  bankName: "은행명",
  bankCardNumber: "은행카드 번호",
  bankCardNumberPlaceholder: "은행카드 번호를 입력하십시오.",
  branchName: "지점 이름",
  branchNumber: "지점 번호",
  selectBank: "은행을 선택하십시오.",
  nameOfPayer: "지불자 이름",
  uploadPaymentVoucher: "결제 자격 증명 업로드",
  rechargePrompt:
    "작업을 반복하지 마십시오.미수금이 장기간 지속되면 고객에게 문의하십시오.",
  confirmRecharge: "충전 확인",
  exchangeRecords: "환전 기록",
  whole: "모두",
  limitDescription: "한도액 설명",
  singleTransactionLimit: "단일 한도액",
  minimum: "최소",
  highest: "최고",
  withdrawalFrequency: "현금 인출 횟수",
  dailyHighest: "일일 최고",
  order: "회",
  freeOfHandlingFees: "(수수료 500회 면제)",
  receiptTime: "입금 시간: 보통 입금 시간은 5분 정도, 빠르면 2분 이내에 입금",
  residualIntegral: "남은 포인트",
  individual: "개",
  redeemPointsNow: "바로 환불",
  headSculpture: "프로필 사진",
  fullName: "이름",
  gender: "성별",
  male: "남자",
  female: "여자",
  unknown: "알 수 없음",
  bankCardInformation: "은행 카드 정보",
  have: "있음",
  notHave: "없음",
  modifyRealName: "실명 수정",
  save: "저장",
  fullNamePlaceholder: "이름을 입력하십시오.",
  modifyRealNameRemake:
    "계좌의 안전성을 확보하기 위해서는 본명이 묶인 은행카드의 명의와 같아야 한다.",
  modifyGender: "성별 수정",
  cardNumber: "은행명",
  cardName: "사용자 이름",
  cardID: "은행카드 번호",
  addBankCard: "은행 카드 추가",
  addBankCardRemake:
    "참고: 대형 상업은행에 문의하십시오.변경이 필요한 경우 온라인으로 고객 서비스에 문의하십시오.",
  payCardInfoPlaceholder: "결제 카드 정보를 입력하십시오.",
  addBankCardPrompt:
    "친애하는 사용자, 자금의 안전을 확보하기 위해서, 당신의 실제 이름을 링크하고 인출 비밀번호를 설정하십시오.계정 이름과 이름이 일치하지 않으면 자금을 인출할 수 없습니다.",
  personalReport: "개인 보고서",
  profitPoints: "이익 포인트",
  profiCalculationFormula: "수익 계산 공식: 당첨 포인트 - 퀘스트 포인트",
  taskPoints: "작업 포인트",
  withdrawalPoints: "포인트 현금 인출",
  winningPoints: "당첨 포인트",
  changeLoginPassword: "로그인 암호 수정",
  oldPwd: "이전 암호",
  oldPwdPlaceholder: "이전 암호를 입력하십시오.",
  newPwd: "새 암호",
  newPwdPlaceholder: "새 암호를 입력하십시오.",
  againOldPwdPlaceholder: "새 암호를 다시 입력하십시오.",
  taskRecord: "작업 레코드",
  emptyData: "데이터가 비어 있음",
  betPoints: "주문 포인트",
  orderTime: "주문 시간",
  settlementTime: "결제 시간",
  refreshSuccessful: "새로 고침 성공",
  invalidFunction: "이 기능은 유효하지 않습니다.",
  appointmentSuccessful: "안내원에게 연락하세요",
  completeActivationTask: "활성화 작업을 완료하십시오.",
  checkAgreement: "아래에서 계좌 개설 협의를 선택하십시오.",
  integralError: "포인트 오류",
  selectNumber: "번호를 선택하세요",
  fillInPoints: "포인트를 기입해 주세요",
  insufficientPoints: "포인트 부족, 고객센터에 연락하여 충전하세요",
  contactCollect: "이 작업은 관리자에게 문의하십시오.",
  successfulLotteryDraw: "당첨 성공, 기호:",
  notSet: "설정되지 않음",
  contactService: "비밀번호를 변경하려면 고객센터에 문의하십시오.",
  completeTask: "퀘스트 리스트를 완성한 후 입장하세요",
  setUpBankCard: "은행카드를 설정해 주세요.",
  accountOffline: "계정 오프라인",
  fileTooLarge: "파일이 너무 큽니다.",
  formatRule: "올바른 형식의 이미지를 업로드하십시오.",
  uploadSuccessful: "업로드 성공",
  amountError: "금액 오류",
  setNameToBindBankCard: "이름을 설정한 후 카드를 바인딩하십시오.",
  setWithdrawalPasswordToBindBankCard:
    "현금인출 비밀번호를 설정한 후 은행카드를 묶으세요",
  passwordInconsistency: "암호 불일치",
  complete: "전체 입력",
  changWithdrawalPasswordContactSustomerService:
    "현금 인출 비밀번호가 설정되었습니다. 수정이 필요하면 고객센터에 연락하십시오.",
  activateWatchVideo: "활성화 후 비디오 보기",
  rechargeWatchVideo: "충전 후 동영상을 보십시오",
  pour: "주",
  taskList: "작업 명세서",
  clearOrder: "주문 비우기",
  confirmSub: "제출 확인",
  switchLanguage: "언어 전환",
  illustrate: "설명",
  submissionTime: "제출 시간",
  auditTime: "감사 시간",
  payPwdPl: "결제 비밀번호를 입력하십시오.",
  enterPayPwdPl: "결제 비밀번호를 다시 입력하십시오.",
  setPayPwd: "결제 비밀번호 설정",
  yse: "예",
  loadingtext: "로드 중...",
  finishedtext: "더 이상 데이터 없음",
  pullingtext: "풀다운하여 업데이트",
  loosingtext: "놓고 새로 고침",
  bettingContent: "주문 내용",
  xinyufen: "신용 점수",
  applyMembershipCard: "멤버십 카드 신청",
  xqaltit: "행복한 행동",
  LastUpdated: "마지막 업데이트",
  tpzx: "투표 센터",
  grzx: "개인 센터",
  ljmfks: "지금 바로 무료로 시작하기",
  rgnyzh: "이미 계정이 있는 분",
  bfwbxsbsyxkf: "만 18세 미만은 이용할 수 없습니다.",
  aqkkdppfw: "안전하고 신뢰할 수 있는 매칭 서비스 형태 ‘IMS 인증’",
  ckgdxqal: "기타 매칭 사례 보기",
  syqlaqkkdyy: "안심하고 사용할 수 있는 이유",
  syqlaqkkdjtnr:
    "진지한 만남을 원하는 이용자분들이 안심하고 안전하게 이용하실 수 있도록 다양한 노력을 기울이고 있습니다.",
  safetit011: "연중무휴 24시간",
  safetit012: "철저한 모니터링 체계",
  safecon01:
    "기술과 전문 인력이 결합된 상시 모니터링 체계를 통해 모든 이용자에게 안전하고 신뢰할 수 있는 서비스를 제공합니다.",
  safetit02: "본인 인증은 필수입니다",
  safecon02:
    "메시지 이용을 위해서는 얼굴 사진이 포함된 공식 신분증을 통한 본인 인증이 필수입니다.",
  safetit03: "실명은 공개되지 않습니다",
  safecon03:
    "프로필은 이니셜 또는 닉네임으로 표시되므로 실명이 공개되지 않습니다.",
  safetit041: "악성 이용자는",
  safetit042: "강제 탈퇴됩니다",
  safecon04:
    "이용자의 신고뿐만 아니라 AI를 활용하여 부정 및 악성 이용자를 탐지하며, 경고 및 강제 탈퇴 등 엄정한 조치를 취하고 있습니다.",
  safetit051: "SNS에는",
  safetit052: "게시되지 않습니다",
  safecon05:
    "LINE 등 SNS 계정으로 가입하더라도 어떠한 게시물도 업로드되지 않습니다.",
  safetit061: "각종 인증을",
  safetit062: "취득하고 있습니다",
  safecon06:
    "개인정보 보안 마크인 ‘TRUSTe 인증’과 건전하게 운영되는 매칭 사업자에게 부여되는 ‘IMS 인증 마크’를 취득하고 있습니다.",
  cwwt: "자주 묻는 질문",
  q1: "무료로 서비스를 이용할 수 있나요?",
  a1:
    "무료로 가입 및 매칭이 가능합니다. 무료 회원의 경우, 남성은 첫 메시지 전송까지 가능하며 여성은 메시지 송수신이 가능합니다.",
  q2: "불특정 다수에게 프로필이 공개되지 않도록 이용할 수 있나요?",
  a2:
    "‘좋아요’를 누르거나 매칭된 상대에게만 프로필이 공개되는 ‘비공개’ 설정을 권장합니다. 해당 기능은 모든 회원이 무료로 이용할 수 있습니다.",
  q3: "문제나 분쟁에 휘말릴까 걱정됩니다",
  a3:
    "안전하고 안심할 수 있는 이용을 위해 정보를 모아둔 ‘세이프티 센터’를 운영하고 있습니다. 그래도 불안함이 남는 경우 고객센터로 문의해 주세요.",
  cbdjmtbd: "는 다수의 미디어에 소개되었습니다",
  gzhyhhjzc: "다양한 결혼·혼활 지원",
  wzzcyzgxm: "프로젝트에 참여하고 있습니다",
  xm1:
    "일본의 결혼 및 혼활을 지원하기 위해 다양한 기업의 후원으로 설립된 일반 사단법인입니다.",
  xm2:
    "결혼을 희망하는 분들이 그 꿈을 실현할 수 있도록 가나가와현에서 추진하는 결혼 지원 사업입니다.",
  xm3:
    "저출산 대책의 일환으로 청년들의 만남을 지원하기 위해 아키타현 요코테시에서 추진하는 ‘청년 만남 응원’ 사업입니다.",
  zxyhfwzch: "인터넷 이성 소개 사업 신고 완료: 시부야 25-001649",
  slfh: "(접수 번호: 30230025-004)",
  sm: "성명",
};
